// extracted by mini-css-extract-plugin
export default {"container":"ScrollDown_container__RbviE","icon":"ScrollDown_icon__p7MHd"};